// eslint-disable-next-line import/prefer-default-export
export const countryCodes = [
  {
    label: "+44",
    value: "United Kingdom +44",
    description: "🇬🇧 United Kingdom",
    maxLength: 10,
  },
  {
    label: "+91",
    value: "India +91",
    description: "🇮🇳 India",
    maxLength: 10,
  },
  {
    label: "+61",
    value: "Australia +61",
    description: "🇦🇺 Australia",
    maxLength: 15,
  },
  {
    label: "+1",
    value: "United States of America +1",
    description: "🇺🇸 United States of America",
    maxLength: 10,
  },
  {
    label: "+1",
    value: "Canada +1",
    description: "🇨🇦 Canada",
    maxLength: 10,
  },
  {
    label: "+234",
    value: "Nigeria +234",
    description: "🇳🇬 Nigeria",
    maxLength: 14,
  },
  {
    label: "+971",
    value: "United Arab Emirates +971",
    description: "🇦🇪 United Arab Emirates",
    maxLength: 12,
  },
  {
    label: "+62",
    value: "Indonesia +62",
    description: "🇮🇩 Indonesia",
    maxLength: 17,
  },
  {
    label: "+376",
    value: "Andorra +376",
    description: "🇦🇩 Andorra",
    maxLength: 9,
  },
  {
    label: "+93",
    value: "Afghanistan +93",
    description: "🇦🇫 Afghanistan",
    maxLength: 9,
  },
  {
    label: "+1268",
    value: "Antigua and Barbuda +1268",
    description: "🇦🇬 Antigua and Barbuda",
    maxLength: 15,
  },
  {
    label: "+1264",
    value: "Anguilla +1264",
    description: "🇦🇮 Anguilla",
    maxLength: 15,
  },
  {
    label: "+355",
    value: "Albania +355",
    description: "🇦🇱 Albania",
    maxLength: 9,
  },
  {
    label: "+374",
    value: "Armenia +374",
    description: "🇦🇲 Armenia",
    maxLength: 8,
  },
  {
    label: "+244",
    value: "Angola +244",
    description: "🇦🇴 Angola",
    maxLength: 9,
  },
  {
    label: "+672",
    value: "Antarctica +672",
    description: "🇦🇶 Antarctica",
    maxLength: 6,
  },
  {
    label: "+54",
    value: "Argentina +54",
    description: "🇦🇷 Argentina",
    maxLength: 11,
  },
  {
    label: "+1684",
    value: "American Samoa +1684",
    description: "🇦🇸 American Samoa",
    maxLength: 15,
  },
  {
    label: "+43",
    value: "Austria +43",
    description: "🇦🇹 Austria",
    maxLength: 13,
  },
  {
    label: "+297",
    value: "Aruba +297",
    description: "🇦🇼 Aruba",
    maxLength: 7,
  },
  {
    label: "+358",
    value: "Åland Islands +358",
    description: "🇦🇽 Åland Islands",
    maxLength: 12,
  },
  {
    label: "+994",
    value: "Azerbaijan +994",
    description: "🇦🇿 Azerbaijan",
    maxLength: 9,
  },
  {
    label: "+387",
    value: "Bosnia and Herzegovina +387",
    description: "🇧🇦 Bosnia and Herzegovina",
    maxLength: 9,
  },
  {
    label: "+1246",
    value: "Barbados +1246",
    description: "🇧🇧 Barbados",
    maxLength: 15,
  },
  {
    label: "+880",
    value: "Bangladesh +880",
    description: "🇧🇩 Bangladesh",
    maxLength: 10,
  },
  {
    label: "+32",
    value: "Belgium +32",
    description: "🇧🇪 Belgium",
    maxLength: 9,
  },
  {
    label: "+226",
    value: "Burkina Faso +226",
    description: "🇧🇫 Burkina Faso",
    maxLength: 8,
  },
  {
    label: "+359",
    value: "Bulgaria +359",
    description: "🇧🇬 Bulgaria",
    maxLength: 12,
  },
  {
    label: "+973",
    value: "Bahrain +973",
    description: "🇧🇭 Bahrain",
    maxLength: 8,
  },
  {
    label: "+257",
    value: "Burundi +257",
    description: "🇧🇮 Burundi",
    maxLength: 8,
  },
  {
    label: "+229",
    value: "Benin +229",
    description: "🇧🇯 Benin",
    maxLength: 10,
  },
  {
    label: "+590",
    value: "Saint Barthélemy +590",
    description: "🇧🇱 Saint Barthélemy",
    maxLength: 9,
  },
  {
    label: "+1441",
    value: "Bermuda +1441",
    description: "🇧🇲 Bermuda",
    maxLength: 15,
  },
  {
    label: "+673",
    value: "Brunei Darussalam +673",
    description: "🇧🇳 Brunei Darussalam",
    maxLength: 7,
  },
  {
    label: "+591",
    value: "Bolivia (Plurinational State of) +591",
    description: "🇧🇴 Bolivia (Plurinational State of)",
    maxLength: 9,
  },
  {
    label: "+5997",
    value: "Bonaire, Sint Eustatius and Saba +5997",
    description: "🇧🇶 Bonaire, Sint Eustatius and Saba",
    maxLength: 15,
  },
  {
    label: "+55",
    value: "Brazil +55",
    description: "🇧🇷 Brazil",
    maxLength: 11,
  },
  {
    label: "+975",
    value: "Bhutan +975",
    description: "🇧🇹 Bhutan",
    maxLength: 8,
  },
  {
    label: "+47",
    value: "Bouvet Island +47",
    description: "🇧🇻 Bouvet Island",
    maxLength: 8,
  },
  {
    label: "+267",
    value: "Botswana +267",
    description: "🇧🇼 Botswana",
    maxLength: 10,
  },
  {
    label: "+375",
    value: "Belarus +375",
    description: "🇧🇾 Belarus",
    maxLength: 11,
  },
  {
    label: "+501",
    value: "Belize +501",
    description: "🇧🇿 Belize",
    maxLength: 11,
  },
  {
    label: "+41",
    value: "Switzerland +41",
    description: "🇨🇭 Switzerland",
    maxLength: 12,
  },
  {
    label: "+225",
    value: "Côte d'Ivoire +225",
    description: "🇨🇮 Côte d'Ivoire",
    maxLength: 10,
  },
  {
    label: "+56",
    value: "Chile +56",
    description: "🇨🇱 Chile",
    maxLength: 11,
  },
  {
    label: "+237",
    value: "Cameroon +237",
    description: "🇨🇲 Cameroon",
    maxLength: 9,
  },
  {
    label: "+86",
    value: "China +86",
    description: "🇨🇳 China",
    maxLength: 12,
  },
  {
    label: "+57",
    value: "Colombia +57",
    description: "🇨🇴 Colombia",
    maxLength: 11,
  },
  {
    label: "+506",
    value: "Costa Rica +506",
    description: "🇨🇷 Costa Rica",
    maxLength: 10,
  },
  {
    label: "+53",
    value: "Cuba +53",
    description: "🇨🇺 Cuba",
    maxLength: 10,
  },
  {
    label: "+238",
    value: "Cabo Verde +238",
    description: "🇨🇻 Cabo Verde",
    maxLength: 7,
  },
  {
    label: "+599",
    value: "Curaçao +599",
    description: "🇨🇼 Curaçao",
    maxLength: 8,
  },
  {
    label: "+61",
    value: "Christmas Island +61",
    description: "🇨🇽 Christmas Island",
    maxLength: 12,
  },
  {
    label: "+357",
    value: "Cyprus +357",
    description: "🇨🇾 Cyprus",
    maxLength: 8,
  },
  {
    label: "+49",
    value: "Germany +49",
    description: "🇩🇪 Germany",
    maxLength: 15,
  },
  {
    label: "+253",
    value: "Djibouti +253",
    description: "🇩🇯 Djibouti",
    maxLength: 8,
  },
  {
    label: "+45",
    value: "Denmark +45",
    description: "🇩🇰 Denmark",
    maxLength: 8,
  },
  {
    label: "+767",
    value: "Dominica +767",
    description: "🇩🇲 Dominica",
    maxLength: 15,
  },
  {
    label: "+213",
    value: "Algeria +213",
    description: "🇩🇿 Algeria",
    maxLength: 9,
  },
  {
    label: "+593",
    value: "Ecuador +593",
    description: "🇪🇨 Ecuador",
    maxLength: 11,
  },
  {
    label: "+372",
    value: "Estonia +372",
    description: "🇪🇪 Estonia",
    maxLength: 10,
  },
  {
    label: "+20",
    value: "Egypt +20",
    description: "🇪🇬 Egypt",
    maxLength: 10,
  },
  {
    label: "+212",
    value: "Western Sahara +212",
    description: "🇪🇭 Western Sahara",
    maxLength: 9,
  },
  {
    label: "+291",
    value: "Eritrea +291",
    description: "🇪🇷 Eritrea",
    maxLength: 7,
  },
  {
    label: "+34",
    value: "Spain +34",
    description: "🇪🇸 Spain",
    maxLength: 9,
  },
  {
    label: "+251",
    value: "Ethiopia +251",
    description: "🇪🇹 Ethiopia",
    maxLength: 9,
  },
  {
    label: "+358",
    value: "Finland +358",
    description: "🇫🇮 Finland",
    maxLength: 12,
  },
  {
    label: "+679",
    value: "Fiji +679",
    description: "🇫🇯 Fiji",
    maxLength: 11,
  },
  {
    label: "+691",
    value: "Micronesia (Federated States of) +691",
    description: "🇫🇲 Micronesia (Federated States of)",
    maxLength: 7,
  },
  {
    label: "+33",
    value: "France +33",
    description: "🇫🇷 France",
    maxLength: 9,
  },
  {
    label: "+241",
    value: "Gabon +241",
    description: "🇬🇦 Gabon",
    maxLength: 8,
  },
  {
    label: "+1473",
    value: "Grenada +1473",
    description: "🇬🇩 Grenada",
    maxLength: 15,
  },
  {
    label: "+995",
    value: "Georgia +995",
    description: "🇬🇪 Georgia",
    maxLength: 9,
  },
  {
    label: "+594",
    value: "French Guiana +594",
    description: "🇬🇫 French Guiana",
    maxLength: 9,
  },
  {
    label: "+44",
    value: "Guernsey +44",
    description: "🇬🇬 Guernsey",
    maxLength: 10,
  },
  {
    label: "+233",
    value: "Ghana +233",
    description: "🇬🇭 Ghana",
    maxLength: 9,
  },
  {
    label: "+350",
    value: "Gibraltar +350",
    description: "🇬🇮 Gibraltar",
    maxLength: 8,
  },
  {
    label: "+299",
    value: "Greenland +299",
    description: "🇬🇱 Greenland",
    maxLength: 6,
  },
  {
    label: "+224",
    value: "Guinea +224",
    description: "🇬🇳 Guinea",
    maxLength: 9,
  },
  {
    label: "+590",
    value: "Guadeloupe +590",
    description: "🇬🇵 Guadeloupe",
    maxLength: 9,
  },
  {
    label: "+240",
    value: "Equatorial Guinea +240",
    description: "🇬🇶 Equatorial Guinea",
    maxLength: 9,
  },
  {
    label: "+30",
    value: "Greece +30",
    description: "🇬🇷 Greece",
    maxLength: 12,
  },
  {
    label: "+500",
    value: "South Georgia and the South Sandwich Islands +500",
    description: "🇬🇸 South Georgia and the South Sandwich Islands",
    maxLength: 5,
  },
  {
    label: "+502",
    value: "Guatemala +502",
    description: "🇬🇹 Guatemala",
    maxLength: 11,
  },
  {
    label: "+1",
    value: "Guam +1",
    description: "🇬🇺 Guam",
    maxLength: 10,
  },
  {
    label: "+245",
    value: "Guinea-Bissau +245",
    description: "🇬🇼 Guinea-Bissau",
    maxLength: 9,
  },
  {
    label: "+592",
    value: "Guyana +592",
    description: "🇬🇾 Guyana",
    maxLength: 7,
  },
  {
    label: "+852",
    value: "Hong Kong +852",
    description: "🇭🇰 Hong Kong",
    maxLength: 11,
  },
  {
    label: "+504",
    value: "Honduras +504",
    description: "🇭🇳 Honduras",
    maxLength: 11,
  },
  {
    label: "+385",
    value: "Croatia +385",
    description: "🇭🇷 Croatia",
    maxLength: 12,
  },
  {
    label: "+509",
    value: "Haiti +509",
    description: "🇭🇹 Haiti",
    maxLength: 8,
  },
  {
    label: "+36",
    value: "Hungary +36",
    description: "🇭🇺 Hungary",
    maxLength: 9,
  },
  {
    label: "+353",
    value: "Ireland +353",
    description: "🇮🇪 Ireland",
    maxLength: 11,
  },
  {
    label: "+972",
    value: "Israel +972",
    description: "🇮🇱 Israel",
    maxLength: 12,
  },
  {
    label: "+44",
    value: "Isle of Man +44",
    description: "🇮🇲 Isle of Man",
    maxLength: 10,
  },
  {
    label: "+964",
    value: "Iraq +964",
    description: "🇮🇶 Iraq",
    maxLength: 10,
  },
  {
    label: "+98",
    value: "Iran (Islamic Republic of) +98",
    description: "🇮🇷 Iran (Islamic Republic of)",
    maxLength: 10,
  },
  {
    label: "+354",
    value: "Iceland +354",
    description: "🇮🇸 Iceland",
    maxLength: 9,
  },
  {
    label: "+39",
    value: "Italy +39",
    description: "🇮🇹 Italy",
    maxLength: 12,
  },
  {
    label: "+44",
    value: "Jersey +44",
    description: "🇯🇪 Jersey",
    maxLength: 10,
  },
  {
    label: "+876",
    value: "Jamaica +876",
    description: "🇯🇲 Jamaica",
    maxLength: 15,
  },
  {
    label: "+962",
    value: "Jordan +962",
    description: "🇯🇴 Jordan",
    maxLength: 9,
  },
  {
    label: "+81",
    value: "Japan +81",
    description: "🇯🇵 Japan",
    maxLength: 17,
  },
  {
    label: "+254",
    value: "Kenya +254",
    description: "🇰🇪 Kenya",
    maxLength: 10,
  },
  {
    label: "+996",
    value: "Kyrgyzstan +996",
    description: "🇰🇬 Kyrgyzstan",
    maxLength: 10,
  },
  {
    label: "+855",
    value: "Cambodia +855",
    description: "🇰🇭 Cambodia",
    maxLength: 10,
  },
  {
    label: "+850",
    value: "North Korea +850",
    description: "🇰🇵 North Korea",
    maxLength: 10,
  },
  {
    label: "+82",
    value: "South Korea +82",
    description: "🇰🇷 South Korea",
    maxLength: 14,
  },
  {
    label: "+686",
    value: "Kiribati +686",
    description: "🇰🇮 Kiribati",
    maxLength: 8,
  },
  {
    label: "+1869",
    value: "Saint Kitts and Nevis +1869",
    description: "🇰🇳 Saint Kitts and Nevis",
    maxLength: 15,
  },
  {
    label: "+965",
    value: "Kuwait +965",
    description: "🇰🇼 Kuwait",
    maxLength: 8,
  },
  {
    label: "+7",
    value: "Kazakhstan +7",
    description: "🇰🇿 Kazakhstan",
    maxLength: 14,
  },
  {
    label: "+961",
    value: "Lebanon +961",
    description: "🇱🇧 Lebanon",
    maxLength: 8,
  },
  {
    label: "+1758",
    value: "Saint Lucia +1758",
    description: "🇱🇨 Saint Lucia",
    maxLength: 15,
  },
  {
    label: "+423",
    value: "Liechtenstein +423",
    description: "🇱🇮 Liechtenstein",
    maxLength: 9,
  },
  {
    label: "+94",
    value: "Sri Lanka +94",
    description: "🇱🇰 Sri Lanka",
    maxLength: 9,
  },
  {
    label: "+231",
    value: "Liberia +231",
    description: "🇱🇷 Liberia",
    maxLength: 9,
  },
  {
    label: "+266",
    value: "Lesotho +266",
    description: "🇱🇸 Lesotho",
    maxLength: 8,
  },
  {
    label: "+370",
    value: "Lithuania +370",
    description: "🇱🇹 Lithuania",
    maxLength: 8,
  },
  {
    label: "+352",
    value: "Luxembourg +352",
    description: "🇱🇺 Luxembourg",
    maxLength: 11,
  },
  {
    label: "+371",
    value: "Latvia +371",
    description: "🇱🇻 Latvia",
    maxLength: 8,
  },
  {
    label: "+218",
    value: "Libya +218",
    description: "🇱🇾 Libya",
    maxLength: 9,
  },
  {
    label: "+212",
    value: "Morocco +212",
    description: "🇲🇦 Morocco",
    maxLength: 9,
  },
  {
    label: "+377",
    value: "Monaco +377",
    description: "🇲🇨 Monaco",
    maxLength: 9,
  },
  {
    label: "+382",
    value: "Montenegro +382",
    description: "🇲🇪 Montenegro",
    maxLength: 12,
  },
  {
    label: "+590",
    value: "Saint Martin (French part) +590",
    description: "🇲🇫 Saint Martin (French part)",
    maxLength: 9,
  },
  {
    label: "+261",
    value: "Madagascar +261",
    description: "🇲🇬 Madagascar",
    maxLength: 10,
  },
  {
    label: "+223",
    value: "Mali +223",
    description: "🇲🇱 Mali",
    maxLength: 8,
  },
  {
    label: "+95",
    value: "Myanmar +95",
    description: "🇲🇲 Myanmar",
    maxLength: 10,
  },
  {
    label: "+976",
    value: "Mongolia +976",
    description: "🇲🇳 Mongolia",
    maxLength: 10,
  },
  {
    label: "+853",
    value: "Macao +853",
    description: "🇲🇴 Macao",
    maxLength: 8,
  },
  {
    label: "+596",
    value: "Martinique +596",
    description: "🇲🇶 Martinique",
    maxLength: 9,
  },
  {
    label: "+222",
    value: "Mauritania +222",
    description: "🇲🇷 Mauritania",
    maxLength: 8,
  },
  {
    label: "+1664",
    value: "Montserrat +1664",
    description: "🇲🇸 Montserrat",
    maxLength: 15,
  },
  {
    label: "+356",
    value: "Malta +356",
    description: "🇲🇹 Malta",
    maxLength: 8,
  },
  {
    label: "+230",
    value: "Mauritius +230",
    description: "🇲🇺 Mauritius",
    maxLength: 10,
  },
  {
    label: "+960",
    value: "Maldives +960",
    description: "🇲🇻 Maldives",
    maxLength: 10,
  },
  {
    label: "+265",
    value: "Malawi +265",
    description: "🇲🇼 Malawi",
    maxLength: 9,
  },
  {
    label: "+52",
    value: "Mexico +52",
    description: "🇲🇽 Mexico",
    maxLength: 10,
  },
  {
    label: "+60",
    value: "Malaysia +60",
    description: "🇲🇾 Malaysia",
    maxLength: 10,
  },
  {
    label: "+258",
    value: "Mozambique +258",
    description: "🇲🇿 Mozambique",
    maxLength: 9,
  },
  {
    label: "+264",
    value: "Namibia +264",
    description: "🇳🇦 Namibia",
    maxLength: 10,
  },
  {
    label: "+687",
    value: "New Caledonia +687",
    description: "🇳🇨 New Caledonia",
    maxLength: 6,
  },
  {
    label: "+672",
    value: "Norfolk Island +672",
    description: "🇳🇫 Norfolk Island",
    maxLength: 6,
  },
  {
    label: "+505",
    value: "Nicaragua +505",
    description: "🇳🇮 Nicaragua",
    maxLength: 8,
  },
  {
    label: "+47",
    value: "Norway +47",
    description: "🇳🇴 Norway",
    maxLength: 8,
  },
  {
    label: "+977",
    value: "Nepal +977",
    description: "🇳🇵 Nepal",
    maxLength: 11,
  },
  {
    label: "+674",
    value: "Nauru +674",
    description: "🇳🇷 Nauru",
    maxLength: 7,
  },
  {
    label: "+683",
    value: "Niue +683",
    description: "🇳🇺 Niue",
    maxLength: 7,
  },
  {
    label: "+64",
    value: "New Zealand +64",
    description: "🇳🇿 New Zealand",
    maxLength: 10,
  },
  {
    label: "+968",
    value: "Oman +968",
    description: "🇴🇲 Oman",
    maxLength: 9,
  },
  {
    label: "+507",
    value: "Panama +507",
    description: "🇵🇦 Panama",
    maxLength: 11,
  },
  {
    label: "+51",
    value: "Peru +51",
    description: "🇵🇪 Peru",
    maxLength: 11,
  },
  {
    label: "+689",
    value: "French Polynesia +689",
    description: "🇵🇫 French Polynesia",
    maxLength: 9,
  },
  {
    label: "+675",
    value: "Papua New Guinea +675",
    description: "🇵🇬 Papua New Guinea",
    maxLength: 11,
  },
  {
    label: "+92",
    value: "Pakistan +92",
    description: "🇵🇰 Pakistan",
    maxLength: 12,
  },
  {
    label: "+48",
    value: "Poland +48",
    description: "🇵🇱 Poland",
    maxLength: 10,
  },
  {
    label: "+508",
    value: "Saint Pierre and Miquelon +508",
    description: "🇵🇲 Saint Pierre and Miquelon",
    maxLength: 9,
  },
  {
    label: "+64",
    value: "Pitcairn +64",
    description: "🇵🇳 Pitcairn",
    maxLength: 10,
  },
  {
    label: "+1",
    value: "Puerto Rico +1",
    description: "🇵🇷 Puerto Rico",
    maxLength: 10,
  },
  {
    label: "+970",
    value: "Palestine, State of +970",
    description: "🇵🇸 Palestine, State of",
    maxLength: 10,
  },
  {
    label: "+351",
    value: "Portugal +351",
    description: "🇵🇹 Portugal",
    maxLength: 11,
  },
  {
    label: "+680",
    value: "Palau +680",
    description: "🇵🇼 Palau",
    maxLength: 7,
  },
  {
    label: "+595",
    value: "Paraguay +595",
    description: "🇵🇾 Paraguay",
    maxLength: 11,
  },
  {
    label: "+974",
    value: "Qatar +974",
    description: "🇶🇦 Qatar",
    maxLength: 11,
  },
  {
    label: "+262",
    value: "Réunion +262",
    description: "🇷🇪 Réunion",
    maxLength: 9,
  },
  {
    label: "+40",
    value: "Romania +40",
    description: "🇷🇴 Romania",
    maxLength: 9,
  },
  {
    label: "+381",
    value: "Serbia +381",
    description: "🇷🇸 Serbia",
    maxLength: 12,
  },
  {
    label: "+7",
    value: "Russia +7",
    description: "🇷🇺 Russia",
    maxLength: 14,
  },
  {
    label: "+250",
    value: "Rwanda +250",
    description: "🇷🇼 Rwanda",
    maxLength: 9,
  },
  {
    label: "+966",
    value: "Saudi Arabia +966",
    description: "🇸🇦 Saudi Arabia",
    maxLength: 10,
  },
  {
    label: "+677",
    value: "Solomon Islands +677",
    description: "🇸🇧 Solomon Islands",
    maxLength: 7,
  },
  {
    label: "+248",
    value: "Seychelles +248",
    description: "🇸🇨 Seychelles",
    maxLength: 7,
  },
  {
    label: "+46",
    value: "Sweden +46",
    description: "🇸🇪 Sweden",
    maxLength: 13,
  },
  {
    label: "+65",
    value: "Singapore +65",
    description: "🇸🇬 Singapore",
    maxLength: 12,
  },
  {
    label: "+290",
    value: "Saint Helena, Ascension and Tristan da Cunha +290",
    description: "🇸🇭 Saint Helena, Ascension and Tristan da Cunha",
    maxLength: 5,
  },
  {
    label: "+386",
    value: "Slovenia +386",
    description: "🇸🇮 Slovenia",
    maxLength: 8,
  },
  {
    label: "+4779",
    value: "Svalbard and Jan Mayen +4779",
    description: "🇸🇯 Svalbard and Jan Mayen",
    maxLength: 15,
  },
  {
    label: "+421",
    value: "Slovakia +421",
    description: "🇸🇰 Slovakia",
    maxLength: 9,
  },
  {
    label: "+232",
    value: "Sierra Leone +232",
    description: "🇸🇱 Sierra Leone",
    maxLength: 8,
  },
  {
    label: "+378",
    value: "Republic of San Marino +378",
    description: "🇸🇲 Republic of San Marino",
    maxLength: 10,
  },
  {
    label: "+221",
    value: "Senegal +221",
    description: "🇸🇳 Senegal",
    maxLength: 9,
  },
  {
    label: "+252",
    value: "Somalia +252",
    description: "🇸🇴 Somalia",
    maxLength: 9,
  },
  {
    label: "+597",
    value: "Suriname +597",
    description: "🇸🇷 Suriname",
    maxLength: 7,
  },
  {
    label: "+211",
    value: "South Sudan +211",
    description: "🇸🇸 South Sudan",
    maxLength: 9,
  },
  {
    label: "+239",
    value: "Sao Tome and Principe +239",
    description: "🇸🇹 Sao Tome and Principe",
    maxLength: 7,
  },
  {
    label: "+503",
    value: "El Salvador +503",
    description: "🇸🇻 El Salvador",
    maxLength: 11,
  },
  {
    label: "+1721",
    value: "Sint Maarten (Dutch part) +1721",
    description: "🇸🇽 Sint Maarten (Dutch part)",
    maxLength: 15,
  },
  {
    label: "+963",
    value: "Syrian Arab Republic +963",
    description: "🇸🇾 Syrian Arab Republic",
    maxLength: 10,
  },
  {
    label: "+235",
    value: "Chad +235",
    description: "🇹🇩 Chad",
    maxLength: 8,
  },
  {
    label: "+228",
    value: "Togo +228",
    description: "🇹🇬 Togo",
    maxLength: 8,
  },
  {
    label: "+66",
    value: "Thailand +66",
    description: "🇹🇭 Thailand",
    maxLength: 13,
  },
  {
    label: "+992",
    value: "Tajikistan +992",
    description: "🇹🇯 Tajikistan",
    maxLength: 9,
  },
  {
    label: "+690",
    value: "Tokelau +690",
    description: "🇹🇰 Tokelau",
    maxLength: 7,
  },
  {
    label: "+670",
    value: "Timor-Leste +670",
    description: "🇹🇱 Timor-Leste",
    maxLength: 8,
  },
  {
    label: "+993",
    value: "Turkmenistan +993",
    description: "🇹🇲 Turkmenistan",
    maxLength: 8,
  },
  {
    label: "+216",
    value: "Tunisia +216",
    description: "🇹🇳 Tunisia",
    maxLength: 8,
  },
  {
    label: "+676",
    value: "Tonga +676",
    description: "🇹🇴 Tonga",
    maxLength: 7,
  },
  {
    label: "+90",
    value: "Turkey +90",
    description: "🇹🇷 Turkey",
    maxLength: 13,
  },
  {
    label: "+868",
    value: "Trinidad and Tobago +868",
    description: "🇹🇹 Trinidad and Tobago",
    maxLength: 15,
  },
  {
    label: "+688",
    value: "Tuvalu +688",
    description: "🇹🇻 Tuvalu",
    maxLength: 7,
  },
  {
    label: "+255",
    value: "United Republic of Tanzania +255",
    description: "🇹🇿 United Republic of Tanzania",
    maxLength: 9,
  },
  {
    label: "+380",
    value: "Ukraine +380",
    description: "🇺🇦 Ukraine",
    maxLength: 10,
  },
  {
    label: "+256",
    value: "Uganda +256",
    description: "🇺🇬 Uganda",
    maxLength: 9,
  },
  {
    label: "+598",
    value: "Uruguay +598",
    description: "🇺🇾 Uruguay",
    maxLength: 13,
  },
  {
    label: "+998",
    value: "Uzbekistan +998",
    description: "🇺🇿 Uzbekistan",
    maxLength: 9,
  },
  {
    label: "+1784",
    value: "Saint Vincent and the Grenadines +1784",
    description: "🇻🇨 Saint Vincent and the Grenadines",
    maxLength: 15,
  },
  {
    label: "+58",
    value: "Venezuela (Bolivarian Republic of) +58",
    description: "🇻🇪 Venezuela (Bolivarian Republic of)",
    maxLength: 10,
  },
  {
    label: "+1284",
    value: "Virgin Islands (British) +1284",
    description: "🇻🇬 Virgin Islands (British)",
    maxLength: 15,
  },
  {
    label: "+1340",
    value: "Virgin Islands (U.S.) +1340",
    description: "🇻🇮 Virgin Islands (U.S.)",
    maxLength: 15,
  },
  {
    label: "+84",
    value: "Vietnam +84",
    description: "🇻🇳 Vietnam",
    maxLength: 10,
  },
  {
    label: "+678",
    value: "Vanuatu +678",
    description: "🇻🇺 Vanuatu",
    maxLength: 7,
  },
  {
    label: "+681",
    value: "Wallis and Futuna +681",
    description: "🇼🇫 Wallis and Futuna",
    maxLength: 9,
  },
  {
    label: "+685",
    value: "Samoa +685",
    description: "🇼🇸 Samoa",
    maxLength: 10,
  },
  {
    label: "+967",
    value: "Yemen +967",
    description: "🇾🇪 Yemen",
    maxLength: 9,
  },
  {
    label: "+262",
    value: "Mayotte +262",
    description: "🇾🇹 Mayotte",
    maxLength: 9,
  },
  {
    label: "+27",
    value: "South Africa +27",
    description: "🇿🇦 South Africa",
    maxLength: 10,
  },
  {
    label: "+260",
    value: "Zambia +260",
    description: "🇿🇲 Zambia",
    maxLength: 9,
  },
  {
    label: "+263",
    value: "Zimbabwe +263",
    description: "🇿🇼 Zimbabwe",
    maxLength: 10,
  },
  {
    label: "+268",
    value: "Eswatini +268",
    description: "🇸🇿 Eswatini",
    maxLength: 9,
  },
  {
    label: "+389",
    value: "North Macedonia +389",
    description: "🇲🇰 North Macedonia",
    maxLength: 8,
  },
  {
    label: "+63",
    value: "Philippines +63",
    description: "🇵🇭 Philippines",
    maxLength: 13,
  },
  {
    label: "+31",
    value: "Netherlands +31",
    description: "🇳🇱 Netherlands",
    maxLength: 11,
  },
  {
    label: "+373",
    value: "Republic of Moldova +373",
    description: "🇲🇩 Republic of Moldova",
    maxLength: 8,
  },
  {
    label: "+220",
    value: "Gambia +220",
    description: "🇬🇲 Gambia",
    maxLength: 7,
  },
  {
    label: "+1",
    value: "Dominican Republic +1",
    description: "🇩🇴 Dominican Republic",
    maxLength: 10,
  },
  {
    label: "+249",
    value: "Sudan +249",
    description: "🇸🇩 Sudan",
    maxLength: 9,
  },
  {
    label: "+856",
    value: "Lao People's Democratic Republic +856",
    description: "🇱🇦 Lao People's Democratic Republic",
    maxLength: 10,
  },
  {
    label: "+886",
    value: "Taiwan, Province of China +886",
    description: "🇹🇼 Taiwan, Province of China",
    maxLength: 11,
  },
  {
    label: "+242",
    value: "Republic of the Congo +242",
    description: "🇨🇬 Republic of the Congo",
    maxLength: 9,
  },
  {
    label: "+420",
    value: "Czechia +420",
    description: "🇨🇿 Czechia",
    maxLength: 12,
  },
  {
    label: "+227",
    value: "Niger +227",
    description: "🇳🇪 Niger",
    maxLength: 8,
  },
  {
    label: "+243",
    value: "Democratic Republic of the Congo +243",
    description: "🇨🇩 Democratic Republic of the Congo",
    maxLength: 9,
  },
  {
    label: "+1 242",
    value: "Commonwealth of The Bahamas +1 242",
    description: "🇧🇸 Commonwealth of The Bahamas",
    maxLength: 15,
  },
  {
    label: "+61 891",
    value: "Cocos (Keeling) Islands +61 891",
    description: "🇨🇨 Cocos (Keeling) Islands",
    maxLength: 15,
  },
  {
    label: "+236",
    value: "Central African Republic +236",
    description: "🇨🇫 Central African Republic",
    maxLength: 8,
  },
  {
    label: "+682",
    value: "Cook Islands +682",
    description: "🇨🇰 Cook Islands",
    maxLength: 5,
  },
  {
    label: "+500",
    value: "Falkland Islands +500",
    description: "🇫🇰 Falkland Islands",
    maxLength: 5,
  },
  {
    label: "+298",
    value: "Faroe Islands +298",
    description: "🇫🇴 Faroe Islands",
    maxLength: 6,
  },
  {
    label: "+672",
    value: "Territory of Heard Island and McDonald Islands +672",
    description: "🇭🇲 Territory of Heard Island and McDonald Islands",
    maxLength: 6,
  },
  {
    label: "+246",
    value: "British Indian Ocean Territory +246",
    description: "🇮🇴 British Indian Ocean Territory",
    maxLength: 13,
  },
  {
    label: "+269",
    value: "Comoros +269",
    description: "🇰🇲 Comoros",
    maxLength: 7,
  },
  {
    label: "+1 345",
    value: "Cayman Islands +1 345",
    description: "🇰🇾 Cayman Islands",
    maxLength: 15,
  },
  {
    label: "+692",
    value: "Republic of the Marshall Islands +692",
    description: "🇲🇭 Republic of the Marshall Islands",
    maxLength: 7,
  },
  {
    label: "+1 670",
    value: "Commonwealth of the Northern Mariana Islands +1 670",
    description: "🇲🇵 Commonwealth of the Northern Mariana Islands",
    maxLength: 15,
  },
  {
    label: "+1 649",
    value: "Turks and Caicos Islands +1 649",
    description: "🇹🇨 Turks and Caicos Islands",
    maxLength: 15,
  },
  {
    label: "+672",
    value: "French Southern and Antarctic Lands +672",
    description: "🇹🇫 French Southern and Antarctic Lands",
    maxLength: 6,
  },
  {
    label: "+246",
    value: "United States Minor Outlying Islands +246",
    description: "🇺🇲 United States Minor Outlying Islands",
    maxLength: 10,
  },
  {
    label: "+39",
    value: "Holy See +39",
    description: "🇻🇦 Holy See",
    maxLength: 12,
  },
  {
    label: "+383",
    value: "Republic of Kosovo +383",
    description: "🇽🇰 Republic of Kosovo",
    maxLength: 12,
  },
  {
    label: "+599",
    value: "Netherlands Antilles +599",
    description: "🇦🇳 Netherlands Antilles",
    maxLength: 7,
  },
];
